const pageNameKey = "treeViewNoOurNodeMachineStructureDragAndDrop";

export const treeViewNoOurNodeMachineStructureDragAndDropEn = {
  [pageNameKey]: {
    subTitle: "Simply Drag And Drop relevant parts",
    hintTitle1: "Select relevant data points and drag and drop or use the",
    hintTitle2: "button to create a new structure here",
    noStructureImgDragAndDropAltText: "No Structure Drag And Drop",
    transferButtonImgAltText: "Transfer Button",
  },
};

export const treeViewNoOurNodeMachineStructureDragAndDropPtBr = {
  [pageNameKey]: {
    subTitle: "Basta arrastar e soltar as partes relevantes",
    hintTitle1:
      "Selecione os pontos de dados relevantes e arraste e solte ou use o",
    hintTitle2: "botão para criar uma nova estrutura aqui",
    noStructureImgDragAndDropAltText: "Sem arrastar e soltar de estrutura",
    transferButtonImgAltText: "Botão de transferência",
  },
};

export const treeViewNoOurNodeMachineStructureDragAndDropDe = {
  [pageNameKey]: {
    subTitle: "Einfach relevante Teile per Drag & Drop verschieben",
    hintTitle1:
      "Wählen Sie relevante Datenpunkte aus und ziehen Sie sie per Drag & Drop oder verwenden Sie die",
    hintTitle2: "Schaltfläche, um hier eine neue Struktur zu erstellen",
    noStructureImgDragAndDropAltText: "Keine Struktur Drag And Drop",
    transferButtonImgAltText: "Transfer Button",
  },
};

export const treeViewNoOurNodeMachineStructureDragAndDropZhHans = {
  [pageNameKey]: {
    subTitle: "简单地拖放相关部分",
    hintTitle1: "选择相关数据点并拖放或使用",
    hintTitle2: "按钮在这里创建新结构",
    noStructureImgDragAndDropAltText: "无结构拖放",
    transferButtonImgAltText: "转移按钮",
  },
};

export const treeViewNoOurNodeMachineStructureDragAndDropIt = {
  [pageNameKey]: {
    subTitle: "Trascina e rilascia le parti rilevanti",
    hintTitle1:
      "Seleziona i nodi desiderati, trascinali e rilasciali oppure usa il",
    hintTitle2: "pulsante per creare una nuova struttura",
    noStructureImgDragAndDropAltText: "Trascina e rilascia",
    transferButtonImgAltText: "Pulsante di trasferimento",
  },
};

export const treeViewNoOurNodeMachineStructureDragAndDropEs = {
  [pageNameKey]: {
    subTitle: "Simplemente arrastra y suelta las partes relevantes",
    hintTitle1:
      "Selecciona los puntos de datos relevantes y arrástralos y suéltalos o usa el",
    hintTitle2: "botón para crear una nueva estructura aquí",
    noStructureImgDragAndDropAltText: "Sin estructura de arrastrar y soltar",
    transferButtonImgAltText: "Botón de transferencia",
  },
};

export const treeViewNoOurNodeMachineStructureDragAndDropNl = {
  [pageNameKey]: {
    hintTitle1:
      "Selecteer relevante datapunten en Drag & Drop ze naar deze structuur of gebruik de knop om hier een nieuwe structuur aan te maken",
    hintTitle2: "knop om hier een nieuwe structuur aan te maken",
    noStructureImgDragAndDropAltText: "Geen structuur voor Drag & Drop",
    subTitle:
      "Verplaats eenvoudig relevante onderdelen via slepen en neerzetten",
    transferButtonImgAltText: "Overdrachtsknop",
  },
};

export const treeViewNoOurNodeMachineStructureDragAndDropTr = {
  [pageNameKey]: {
    hintTitle1: "İlgili veri noktalarını seçin ve sürükleyip bırakın veya",
    hintTitle2: "burada yeni bir yapı oluşturmak için düğmeye basın",
    noStructureImgDragAndDropAltText: "Yapı Sürükle ve Bırak Yok",
    subTitle: "İlgili kısımları Basitçe Sürükleyip Bırakın",
    transferButtonImgAltText: "Aktarma Düğmesi",
  },
};
